<template>
<div id="irecordlist" class="right-content">

  <el-form :model="filters" class="head-form">
        <el-row type="flex" justify="center" :gutter="20">
      <el-col :xs="6" :sm="6" :md="6" :lg="4">
            <el-form-item prop="category">
              <el-select v-model="filters.category" clearable placeholder="全部" @change="handleCategoryChange">
                <el-option
                  v-for="item in formatCategory"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="16" :sm="16" :md="16" :lg="10">
            <el-form-item prop="editor">
              <el-select v-model="filters.editor" clearable placeholder="选择编辑" @change="handleUserChange">
                <el-option
                  v-for="item in formatUsers"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
    </el-form>

    <emptyCont :show="!getNewsdataLen"></emptyCont>
    <contentList :newsdata='formatNewsData' :labelname='label' :goUrl='goEdit' :limit='limit' :total='newstotal' tipshow='tipshow' :handlePageChange='handlePageChange' :urladdr='linkpath'> </contentList>

    <!--分页-->
  <div class="nav-pagin">
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="22" :lg="14" class="el-item shadow">
        <el-pagination layout="total, prev, pager, next, jumper" :current-page.sync="page" @current-change="handlePageChange" :page-size="limit" :total="newstotal">
        </el-pagination>
      </el-col>
    </el-row>
  </div>


</div>
</template>

<script type="text/javascript">
/**
 * 销售数据概览页组件
 */
import {mapGetters, mapActions} from 'vuex';
import cookie from 'react-cookie';
import { getNowTime, routeMap, cloneObj } from '../../utils/com.js'
import '../../static/style/irecord/list.scss'
import { newsType, hotsType, newsPlatform, auditFullType } from '../../config/config'
import emptyCont from '../common/emptycontent.vue'
import contentList from '../common/contentlist.vue'

export default {
    data() {
        return {
            filters: {
                category: '',
                editor: cookie.load('ibroadcasteditor') || '',
            },
            currentDate: new Date(),
            date: getNowTime(),
            page: 1,
            limit: 10,
            state: 2,
            label: '录音已上传',
            linkpath: './edit',
            type: 1,
            users: null,
            // date: new Date().format("yyyy-MM-dd")
        }
    },
    created() {
        // this.$store.dispatch('getEditorData')
        // let param = {
        //     state: this.state,
        //     category: this.$store.state.route.query.type || '',
        //     page: this.page,
        //     limit: this.limit,
        // }
        // console.debug("created> param:%o", param);
        // // this.getEditorData(param);

        // this.updateLoadingStatus(true);
        // this.getNewsData(param).then(
        //   (resp) => {
        //     this.updateLoadingStatus(false);
        //     console.debug("created> getNewsData> resp:%o", resp);
        //     if(resp && resp.code !== 0){
        //       that.$message({
        //             message: resp.msg,
        //             type: 'error'
        //         });
        //     }
        //   }
        // );
        let curpage = this.$route.query.page || 1;
        this.page = parseInt(curpage);
        this.filters.category = this.$route.query.category || '';
        this.filters.editor = cookie.load('ibroadcasteditor') || (this.$route.query.editor || '');
        this.reqNewsListData();
        this.reqUserListData();
    },
    watch: {
        '$route' (to, from){
            console.debug("watch>route start to:%o, from:%o", to, from);
            // const toDepth = to.path.substring(0, to.path.length-2).split('/').length
            // const fromDepth = from.path.substring(0, from.path.length-2).split('/').length
            // this.transitionName = toDepth < fromDepth ? 'slide' : 'slide_back'
            console.debug("watch>route category:%o, page:%o", this.$route.query.category, this.transitionName, this.$route.query.page);
            let curpage = this.$route.query.page || 1;
            this.page = parseInt(curpage);
            this.filters.category = this.$route.query.category || '';
            this.filters.editor = cookie.load('ibroadcasteditor') || this.$route.query.editor || '';
            this.reqNewsListData();
        }
    },
    computed: {
        ...mapGetters({
            // 映射 this.newsdata 为 store.getters.newsdata
            newsdata: 'newsdata',
            newstotal: 'newstotal',
            getToken: 'getToken',
            getAccount: 'getAccount',
            getRole: 'getRole',
        }),
        getNewsdataLen: function() {
            // console.debug("getNewsdataLen> newsdata.length:%o", this.newsdata.length);
            return this.newsdata.length;
        },
        formatCategory(){
          let typelists = [];
          for(let i in newsType){
            let typelist = {}
            typelist.value = i;
            typelist.label = newsType[i];
            typelists.push(typelist);
          }
          console.debug("formatCategory> typelists:%o", typelists);
          return typelists;
        },
        formatUsers (){
          let userlists = [];
          for(let i in this.users){
            let userlist = {}
            userlist.value = this.users[i].user_name;
            userlist.label = this.users[i].user_name;
            userlists.push(userlist);
          }
          console.debug("formatUsers> userlists:%o", userlists);
          return userlists;
        },
        formatNewsData: function () {
              // `this` points to the vm instance
              let lists = [];
              // console.debug("newsdata:%o", this.newsdata);
              for(let i in this.newsdata){
                let l = {};
                let newdata = this.newsdata[i];
                l = cloneObj(newdata);
                let hi = newdata.hotindex+'' || '7';
                l.hotindex =hotsType[hi];
                // let sf = newdata.sourcefrom || '';
                // l.sourcefrom = newsPlatform[sf];
                let cat = newdata.category || '1';
                l.category = newsType[cat];
                let ls = newdata.labels || '#';
                l.labels = ls.split('#');
                let ss = newdata.state || '1';
                l.state = auditFullType[ss];

                // console.debug("formatMarkers> newsdata:%o, ls:%o", newdata, ls);
                l.labels = ls.split('#');
                lists.push(l);
              }
              // console.debug("formatMarkers> lists:%o", lists);
              return lists;
            }
    },
    methods: {
        ...mapActions({
          // 映射 this.getEditorData() 为 this.$store.dispatch('getEditorData')
          getEditorData: 'getEditorData',
          updateNewsContent: 'updateNewsContent',
          getNewsData: 'getNewsData',
          updateLoadingStatus: 'updateLoadingStatus',
          getUserList: 'getUserList',
        }),
        reqNewsListData() {
          var that = this;
            let param = {
                state: that.state,
                category: that.filters.category,
                page: that.page,
                limit: that.limit,
                editor: that.filters.editor,
            }
            console.debug("reqNewsListData> param:%o", param);
            that.updateLoadingStatus(true);
            that.getNewsData(param).then(
              (resp) => {
                that.updateLoadingStatus(false);
                console.debug("reqNewsListData> resp:%o", resp);
                if(resp && resp.code !== 0){
                  that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }
              }
            );
        },
        goEdit(item){
            if(!item){
                return false;
            }
            item.labels = item.labels.join('#');
            for(let i in newsType){
                if(newsType[i] === item.category){
                    item.category = i;
                    break;
                }
            }
            // for(let i in newsPlatform){
            //     if(newsPlatform[i] === item.sourcefrom){
            //         item.sourcefrom = i;
            //         break;
            //     }
            // }
            for(let i in hotsType){
                if(hotsType[i] === item.hotindex){
                    item.hotindex = i;
                    break;
                }
            }
            console.debug("goto> item:%o", item);
            this.updateNewsContent(item);
            this.$router.push({ path: './edit',query: { id:item.id }})
            // this.$router.push({ path: './edit',query: { id:index }})
            //this.$router.push('./edit');
        },
        handleCategoryChange(val) {
            console.debug("handleCategoryChange> val:%o", val);
            // this.reqNewsListData();
            this.$router.push({ path: routeMap('/irecord/list'), query: { page: this.page, category: this.filters.category, editor: this.filters.editor } });
            console.debug("handlePageChange> query:%o, category:%o", this.$route.query, this.filters.category);
        },
        handlePageChange(val) {
          console.debug("handlePageChange> val:%o", val);
          // if(this.page !== val){
          //   this.page = val;
            // let param = {
            //     state: this.state,
            //     category: this.$store.state.route.query.type || '',
            //     page: this.page,
            //     limit: this.limit,
            // }
            // console.debug("handlePageChange> getNewsData> param:%o", param);
            // // this.getEditorData(param);

            // this.updateLoadingStatus(true);
            // this.getNewsData(param).then(
            //   (resp) => {
            //     this.updateLoadingStatus(false);
            //     console.debug("handlePageChange> getNewsData> resp:%o", resp);
            //     if(resp && resp.code !== 0){
            //       that.$message({
            //             message: resp.msg,
            //             type: 'error'
            //         });
            //     }
            //   }
            // );

            // this.reqNewsListData();
          // }
            this.$router.push({ path: routeMap('/irecord/list'), query: { page: this.page, category: this.filters.category, editor: this.filters.editor } });
          console.debug("handlePageChange> query:%o, category:%o", this.$route.query, this.filters.category);
        },
        handleUserChange(val) {
            console.debug("handleUserChange> val:%o", val);
            var exp = new Date()
            exp.setTime(exp.getTime() + 1 * 24 * 60 * 60 * 1000)
            // 保存token
            cookie.save('ibroadcasteditor', this.filters.editor, {
                path: '/',
                expires: exp
            })
            // this.reqNewsListData();
            this.$router.push({ path: routeMap('/irecord/list'), query: { page: this.page, category: this.filters.category, editor: this.filters.editor } });
            console.debug("handlePageChange> query:%o, user:%o", this.$route.query, this.filters.editor);
        },
        reqUserListData() {
          var that = this;
            let param = {
                type: that.type
            }
            console.debug("reqUserListData> param:%o", param);
            that.updateLoadingStatus(true);
            that.getUserList(param).then(
              (resp) => {
                that.updateLoadingStatus(false);
                console.debug("reqUserListData> resp:%o, users:%o", resp, that.users);
                if(resp && resp.code !== 0){
                  that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }else{
                    that.users = resp.data.users;
                }
              }
            );
        }
    },
    components: {
        emptyCont,
        contentList
    }
}
</script>



// WEBPACK FOOTER //
// list.vue?0b2e0a28